import * as React from "react";
import { Nav, Navbar } from "react-bootstrap";

// import { SwitchLocale } from "src/components/localization/switch-locale";

/* eslint-disable import/no-webpack-loader-syntax */
import CompanyLogoIcon from "-!svg-react-loader!../../images/psg-logo.svg";
/* eslint-enable import/no-webpack-loader-syntax */

const Footer: React.StatelessComponent<{}> = () => (
  <React.Fragment>
    <Navbar collapseOnSelect={false} fluid={true}>
      <Navbar.Header>
        <Navbar.Brand>
          <CompanyLogoIcon className="company-logo" width="152px" height="57px" />
        </Navbar.Brand>
        <Navbar.Toggle />
      </Navbar.Header>
      <Navbar.Collapse>
        <Navbar.Text />
        <Nav pullRight={true}>{/* <SwitchLocale /> */}</Nav>
      </Navbar.Collapse>
    </Navbar>
  </React.Fragment>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/login-header/index.tsx